<script>
  import { _ } from 'svelte-i18n';

  import Step from "./Step.svelte";
  import StepHeader from "./StepHeader.svelte";
  import ExerciseVerification from "./ExerciseVerification.svelte";
  import { preprocess, check, save } from "./ExerciseVerification.svelte";

  export let course;
  export let mod;
  export let step;
  export let justified;
  export let prevFn;
  export let nextFn;

  let badSyntax = false;
  let passedExercise;

  let task_descriptions = [], assignments = [];

  function updateAssignments() {
    assignments.forEach( (el, i) => el.givenAnswer = i + 1 );
  }

  function swapAssignments(i, j) {
    [assignments[i], assignments[j]] = [assignments[j], assignments[i]];
  }

  function shuffleAssignments() {
    let currentIndex = assignments.length, randomIndex;

    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      swapAssignments(currentIndex, randomIndex);
    }
  }

  function checkAssignments(ev) {
    passedExercise = check(assignments);
    save(mod, step, assignments);
    assignments = assignments; // triggers update
  }

  function moveUp(assignment) {
    return function(ev){
      let i =  assignment.givenAnswer -1;
      swapAssignments(i, i-1);
      updateAssignments();
    }
  }

  function moveDown(assignment) {
    return function(ev){
      let i = assignment.givenAnswer -1;
      swapAssignments(i, i+1);
      updateAssignments();
    }
  }

  try {
    [task_descriptions, assignments] = preprocess(step.content, '');
  } catch {
    badSyntax = true;
  }

  shuffleAssignments();
  updateAssignments();
</script>

<Step {justified} {prevFn} {nextFn}>
  <StepHeader {course} {mod} />

  <div class:hidden="{!badSyntax}">
    <ExerciseVerification {course} {mod} {step} />
  </div>

  <div class:hidden="{badSyntax}" class="w-11/12 mt-4 mb-4 bg-base-200">

    {#if passedExercise === true}
      <div class="my-8">
        <img class="mx-auto" src="/assets/test_passed.svg" />
        <p class="text-4xl pt-4 font-bold text-center uppercase"> {$_('course.good_job')} </p>
      </div>

    {:else}
      <div class="card w-3/4 my-10 mx-auto pt-4 relative">
        <div class="card-body pt-2 px-16 z-20">
          <div class="prose max-w-none">
            <h2 class="text-4xl font-bold text-center mb-2"> {step.title} </h2>

            <h5 class="font-bold text-center">
              {#each task_descriptions as desc}
                {@html desc.innerHTML}
              {/each}
            </h5>
          </div>

          <ul class="mt-8 mb-20">
            {#each assignments as a, i}
              <li bind:this="{a.answer}" class="ml-10 mt-6 relative">
                <span class="inline-block align-top w-2 text-center mr-2"
                  class:text-primary={a.correctness === true}
                  class:text-error={a.correctness === false}>
                  {#if a.correctness == true}
                    ✓
                  {:else if a.correctness == false}
                    ✗
                  {:else} 
                    •
                  {/if}
                </span>

                <div class="inline-block">
                  <button class="btn btn-xs btn-square btn-primary"
                  disabled="{i == 0}"
                  on:click={moveUp(a)}>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 320 512"><path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>
                  </button>
                  <button class="btn btn-xs btn-square btn-primary"
                  disabled="{i == assignments.length-1}"
                  on:click={moveDown(a)}>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 320 512"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>
                  </button>
                </div>

                {@html a.innerHTML}
              </li>
            {/each}
          </ul>

          <button class="btn btn-primary" on:click="{checkAssignments}">
            {passedExercise === undefined ? $_('course.check') : $_('course.retry')}
          </button>
        </div>
      </div>
    {/if}

  </div>
</Step>